import { UserFormI } from 'src/models/admin';
import { apiRequest } from 'src/utils/api';
import { ApiPath } from 'src/enums/apiPath';

export const getPositions = async (params?: { [key: string]: any }) => {
  const res = await apiRequest.get({
    url: ApiPath.ADMIN_POSITIONS,
    params: params
  });
  return res.data;
};

export const createUser = async (data: UserFormI) => {
  const res = await apiRequest.post({
    url: ApiPath.ADMIN_USERS,
    data
  });
  return res.data;
};

export const updateUser = async (data: UserFormI, id?: string | number) => {
  if (!id) return;
  const res = await apiRequest.put({
    url: `${ApiPath.ADMIN_USERS}/${id}`,
    data
  });
  return res.data;
};

export const getUser = async (id?: string) => {
  const res = await apiRequest.get({
    url: `${ApiPath.ADMIN_USERS}/${id}`
  });
  return res.data;
};

export const getUserDetail = async (id?: string) => {
  const res = await apiRequest.get({
    url: `${ApiPath.ADMIN_USERS}/${id}/detail`
  });
  return res.data;
};

export const getListUsers = async (params?: { [key: string]: any }) => {
  const res = await apiRequest.get({
    url: ApiPath.ADMIN_USERS,
    params: params
  });
  return res.data;
};

export const deleteUser = async (id?: string) => {
  const res = await apiRequest.delete({
    url: `${ApiPath.ADMIN_USERS}/${id}`
  });
  return res.data;
};

export const getPermissionOfAgencyAccount = async (id: string) => {
  const res = await apiRequest.get({
    url: `${ApiPath.ADMIN_AGENCY_AUTHORITY}/${id}/display`
  });
  return res.data;
};
